import { Outlet } from "react-router-dom";

import { lazyWithRetry } from "@/lib/lazyWithRetry";
import { useCan, type Capability } from "@/lib/roles";

const RoleBlockedPage = lazyWithRetry(
  () => import("@/routes/admin/RoleBlocked"),
);

/**
 * Route-level role guard (FEAT-28), nested INSIDE `RequireAuth` — so a session
 * exists by the time this renders. A pathless layout route: the pages under it
 * mount only for a role holding `capability`; anyone else gets the notice
 * page, and none of the page's own queries ever fire (they would 403).
 *
 * UX only, like every guard in this tree: the server's role gate
 * (`backend/permissions.py`) is the boundary.
 */
export function RequireCapability({ capability }: { capability: Capability }) {
  const canDo = useCan();
  return canDo(capability) ? <Outlet /> : <RoleBlockedPage />;
}
